import { useEffect, useState } from "react";
import ReactLottie from "react-lottie";
import './SharePage.less'
import { Image, Mask, Swiper, Toast } from 'antd-mobile';
// import { SwiperRef } from 'antd-mobile/es/components/swiper'
import { isWeChat, isAndroid, isiOS, onToUserPage, getUrlParams, ToggleCopy, openApp } from '@/utils/common'
// 图片
import title from "@/image/sharePage/title.png"
import no_record from "@/image/sharePage/no-record.png"
import notify from "@/image/sharePage/notify.png"
import jsonData from '@/image/sharePage/data.json'
import decoration from "@/image/sharePage/decoration.png"
import copy from '@/image/common/copy.svg'
// api
import { getShareDetail } from '@/api/share-page'
import { getAppQrcode } from "@/api/app-qrcode";
// 组件
import PrettyNumberTab from '@/component/Tab/pretty-number-tab';

const SharePage = (props:any) => {
  const [visible, setVisible] = useState<boolean>(false) // 遮罩--提示用户打开默认浏览器
  const [is_close, setIsClose] = useState<number>(1) // 该数据是否不可查看(1:是)
  const [imgs, setImgs] = useState<Array<string>>([]) // 图片
  const [type_name, setTypeName] = useState<string>('') // 用户、房间名称
  const [type_id, setTypeId] = useState<string>('') // 页面展示用的ID
  const [pretty_number, setPrettyNumber] = useState<string>('') // 页面展示用的ID
  const [open_app_type_id, setOpenAppTypeId] = useState<string>('') // 打开APP需要传的ID	
  const [share_type, setShareType] = useState<string>('') // 分类类型(room/dynamic/video/user_info)	
  const [appUrl, setAppUrl] = useState<string>('')
  // const ref = useRef<SwiperRef>(null)
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: jsonData,
    rendererSettings: {}
  }

  useEffect(() => {
    getShareDetail(getUrlParams('share_code')).then(e=> {
      setIsClose(e.is_close)
      setImgs(e.imgs || [])
      setTypeName(e.type_name)
      setTypeId(e.type_id)
      setPrettyNumber(e?.pretty_number)
      setOpenAppTypeId(e.open_app_type_id)
      setShareType(e.share_type)
    })

    const reloadPage = () => {
      if (document.visibilityState === 'visible') {
        window.name = 'isReload'
        window.location.reload()
      }
    }

    window.addEventListener('visibilitychange', reloadPage)

    return () => {
      window.removeEventListener('visibilitychange', reloadPage);
    }
  }, [])

  const items = imgs.map((url, index) => (
    <Swiper.Item key={index}>
      <Image src={url} fit='cover' />
    </Swiper.Item>
  ))

  const wakeGetAppQrcode = () => {
    getAppQrcode().then((res:any) => {
      setAppUrl(isAndroid ? res.android_apk_url : isiOS ? res.ios_apk_url : res.android_apk_url)
    })
  }
  if (!appUrl) wakeGetAppQrcode()

  const downBtnFunc = () => {
    if (!appUrl || appUrl === 'undefined' || appUrl === 'null') Toast.show('下载失败，请稍后刷新页面再试！')
    else window.location.href = appUrl
  }

  const toPage = () => {
    if (isiOS) openApp(open_app_type_id, is_close === 1 ? '' : share_type === 'room' ? 'live_room' : share_type === 'dynamic' ? 'dynamic_detail' : 'homepage', share_type === 'video' ? 2 : 0)
    else if (isWeChat) setVisible(true)
    else {
      onToUserPage(open_app_type_id, is_close === 1 ? '' : share_type === 'room' ? 'live_room' : share_type === 'dynamic' ? 'dynamic_detail' : 'homepage', share_type === 'video' ? 2 : 0)

      setTimeout(() => {
        if (document.visibilityState === "visible") downBtnFunc()
      }, 2000)
    } 
  }

  return (
    <div className='share-page'>
      <Mask visible={visible} getContainer={document.body}>
        <Image src={notify} fit='contain' width='56%' className="wx_notify" />
      </Mask>

      <nav>
        <Image src={title} fit='contain' className='title' />
        <span onClick={toPage}>立即打开</span>
      </nav>

      {
        is_close === 1 ?
        <section className='no-data'>
          <Image src={no_record} fit='contain' />
          <p>{share_type === 'room' ? '当前房间不可查看~' : '当前用户信息不可查看~'}</p>
        </section> :
        share_type === 'room' ?
        <section className='live-broadcast'>
          <div className="user-avator">
            <ReactLottie width="44vw" options={defaultOptions} />
            <Image src={imgs[0]} fit='contain' />
          </div>
          <p>{type_name}</p>
          {
            pretty_number ? <PrettyNumberTab prettyNumber={pretty_number} /> :
            <span>ID: {type_id}</span>
          }
        </section> :
        <section className='user-info'>
          <div className="user_box">
            <Swiper indicatorProps={{color: 'white'}} autoplay loop>{items}</Swiper>
          </div>
          <Image src={decoration} fit='contain' className="decoration" />
          <p>{type_name}</p>
          {
            pretty_number ? <span><PrettyNumberTab prettyNumber={pretty_number} /><Image src={copy} fit='contain' onClick={() => ToggleCopy(pretty_number)} /></span> :
            <span>ID: {type_id}<Image src={copy} fit='contain' onClick={() => ToggleCopy(type_id)} /></span>
          }
        </section>
      }

      <footer>
        <span onClick={toPage}>{is_close === 1 ? (share_type === 'room' ? '去App找更多房间' : '去App找更多用户') : share_type === 'room' ? '正在直播中，去APP观看' : '去App查看Ta的主页'}</span>
      </footer>
    </div>
  )
}

export default SharePage